/** Shared route constants for performance-tracking presentation */
export const performanceRoutes = {
  /** ເຂົ້າໜ້າຫຼັກມຸມປະສິດ — ລາຍການ KPI ສ່ວນຕົວ/ຜະແນກ */
  hub: "/app/performance/kpi",
  kpi: "/app/performance/kpi",
  tasks: "/app/performance/tasks",
  kpiDetail: (assignmentId: string) =>
    `/app/performance/kpi/${assignmentId}` as const,
  /** ວຽກຂອງຂ້ອຍໃນໂຄງການ (projectId ໃນ path). */
  projectMyTasks: (projectId: string) =>
    `/app/performance/projects/${projectId}` as const,
  exitToAppHome: "/app/dashboard",
} as const;
